// Only signed JWT strings belong in storage or an Authorization header.
export const isAuthToken = (token) =>
    typeof token === "string" && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token);
